<section class="pt-2">
  <div class="container-style">
    <div class="row align-items-center mx-0 p-1">
      <div class="col-lg-6 col-md-12 col-sm-12 col-12">
        <h6 *ngIf="!devolutionModel.isPredevolution">
          {{ isFormView ? 'Registrar detalle de devolución' : 'Detalle de devolución' }}
        </h6>
        <h6 *ngIf="devolutionModel.isPredevolution">
          {{ isFormView ? 'Registrar detalle de predevolución' : 'Detalle de predevolución' }}
        </h6>
      </div>
      <div class="col-lg-6 col-md-12 col-sm-12 col-12 d-flex justify-content-end">
        <div class="d-flex gap-2">
          <app-custom-button [label]="'Nuevo Detalle'" [severity]="'success'" [disabled]="disabledDetail"
            [width]="'6.5rem'" (onClick)="createNewDetail()"></app-custom-button>
        </div>
      </div>
    </div>
    <div [hidden]="!isFormView" class="row mx-0">
      <div class="col-lg-12 col-md-12 col-sm-12 col-12">
        <app-register-devolution-detail [devolutionModel]="devolutionModel"
          [devolutionDetailContract]="devolutionDetailModel" (updateListDetail)="getDevolutionDetailsByDevolution()"
          [isFormViewOpen]="isFormViewOpen" (isFormView)="getFormView($event)"></app-register-devolution-detail>
      </div>
    </div>
    <div class="col-lg-12 col-md-12 col-sm-12 col-12">
      <app-custom-table [headers]="detailHeader" [data]="detailData" [actions]="tableActions"
        [showCheckbox]=" !this.disabledDetail " [checkBoxAction]="checkboxActions"
        [clearSelectionTrigger]="clearSelectionTrigger" (onRecoverData)="getDevolutionDetailsByDevolution()"
        (onPageChange)="onPageChange($event)" (onAction)="onAction($event)">
      </app-custom-table>
    </div>
  </div>
</section>